import React, {FC} from 'react';
import {GxCheckbox, GxInput} from '@garpix/garpix-web-components-react';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import cnBind from 'classnames/bind';
import DatePicker from 'react-multi-date-picker';
import styles from '../../styles/index.module.scss';
import Select from '../../../../components/Select';
import {DAYS_TASK} from '../../const';
import CalendarInput from '../../../../components/CalendarInput';
import {DAYS_WEEK_TASK, MONTH_WEEK_TASK} from '../../../Tasks/const';
import {getStringValues} from '../../../Applications/helpers';

interface ITabGroupsRepeat {
    flag: boolean;
    handleClickTab: (name: string)=>void;
    formik: any,
}
const cn = cnBind.bind(styles);

const TabGroupsRepeat:FC<ITabGroupsRepeat> = ({flag,handleClickTab,formik}) => {
    return (
        <div className={cn({
            'tab-group': true,
            'tab-group--active': flag
        })}>
            <div className={styles['tab-group--container']}>
                <h2>Повторяемость</h2>
                <p className={styles['tab-group--action']}
                   onClick={() => handleClickTab('repeatTab')}>{flag ? 'Свернуть' : 'Развернуть'}</p>
            </div>
            <div className={cn(styles['form'], styles['tab-group--item'])}>
                <GxCheckbox
                    className={styles['form--type']}
                    checked={formik.values.is_repeat}
                    onGx-change={(e: Record<string, any>) => formik.setFieldValue('is_repeat', e.target.checked)}
                >
                    Повторять:
                </GxCheckbox>
                <div className={cn(styles['form--container'], styles['form--mobile'])}>
                    {/* <div className={cn(styles['form--item'], styles['form--item__group'])}> */}
                    {/*    <span className={styles['label']}>Цикл:</span> */}
                    {/*    <Select */}
                    {/*        options={TYPE_REPEAT_TASK} */}
                    {/*        onChange={(selectedOption: any) => formik.setFieldValue('repeat_by', selectedOption && selectedOption.value)} */}
                    {/*    /> */}
                    {/* </div> */}
                    <div className={cn(styles['form--item'], styles['form--item__group'])}>
                        <span className={cn(styles['label'], styles['label--order'])} style={{textAlign:'left'}}>Время:</span>
                        <div className={styles['form--item__row']}>
                            <DatePicker
                                render={<CalendarInput type='clock' />}
                                disableDayPicker
                                format="HH:mm:ss"
                                plugins={[
                                    <TimePicker />
                                ]}
                                onChange={(date: any) => formik.setFieldValue('repeat_time_at', date.format('HH:mm:ss'))}
                            />
                        </div>
                    </div>
                </div>
                <div className={cn(styles['form--item'], styles['form--item__group'])}>
                    <span className={styles['label']}>Дни недели:</span>
                    <Select
                        name='repeat_dow'
                        options={DAYS_WEEK_TASK}
                        isMulti
                        onChange={(selectedOption: any) => formik.setFieldValue('repeat_dow', getStringValues(selectedOption))}
                    />
                </div>
                <div className={cn(styles['form--item'], styles['form--item__group'])}>
                    <span className={styles['label']}>Месяц:</span>
                    <Select
                        name='repeat_month'
                        options={MONTH_WEEK_TASK}
                        isMulti
                        onChange={(selectedOption: any) => formik.setFieldValue('repeat_month', getStringValues(selectedOption))}
                    />
                </div>
                <div className={cn(styles['form--item'], styles['form--item__group'])}>
                    <span className={styles['label']}>Числа:</span>
                    <Select
                        name='repeat_day'
                        options={DAYS_TASK}
                        isMulti
                        onChange={(selectedOption: any) => formik.setFieldValue('repeat_day', getStringValues(selectedOption))}
                    />
                </div>
                <div className={styles['form--item']}>
                    <GxInput
                        label='Кол-во повторений:'
                        type='number'
                        name='repeat_count_remain'
                        className={cn(styles['form--input'], styles['form--input__wrap'])}
                        value={formik.values.repeat_count_remain}
                        min={1}
                        onGx-change={(e: Record<string, any>) => {
                            if(Number(e.target.value) > 0){
                                formik.setFieldValue('repeat_count_remain', e.target.value)
                            }
                        }}
                    />
                </div>

            </div>
        </div>
    );
};

export default TabGroupsRepeat;
